import { Component, OnInit, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import _ from 'lodash';
import { HttpClient } from '@angular/common/http';

const GUEST_TAG_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => GuestTagComponent),
  multi: true
};

@Component({
  selector: 'host-guest-tag',
  templateUrl: './guest-tag.component.html',
  styleUrls: ['./guest-tag.component.scss'],
  providers: [ GUEST_TAG_VALUE_ACCESSOR ]
})
export class GuestTagComponent implements OnInit, ControlValueAccessor {
  private readonly tagListApi = '/api/house_status_setting/get'
  listOfTag = [];

  default = [];

  dropdownVisible = false;

  emitChange = (p: any) => { };
  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit() {
    this.requestTagList();
  }

  writeValue (value = []) {
    this.default = value;

    this.markCheckedTags();
    // this.selected = value.map(id => {
    //   return this.listOfTag.find(tag => tag.id === id)
    // });
  }

  markCheckedTags () {
    this.listOfTag = this.listOfTag.map(tag => {
      let selected = false;
      if (this.default.find(t => t.id === tag.id)) {
        selected = true;
      }
      return { ...tag, selected };
    });
  }

  requestTagList () {
    this.http.get(this.tagListApi).subscribe(res => {
      this.listOfTag = _.filter((_.get(res, 'data.client_tag_list') || []), tag => !tag.delete_time);
      this.markCheckedTags();
      // this.onCheckedChange();
    });
  }

  onCheckedChange () {
    this.emitChange(this.listOfTag.filter(tag => tag.selected));
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }
  registerOnTouched(fn: any): void { }

}
